//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

module.exports.gagoSources = {
    lerc_v2: {
        type: {
            required: true,
            type: "enum",
            values: {
                raster: {
                    doc: "A raster tile source.",
                },
                "raster-dem": {
                    doc: "A raster DEM source using Mapbox Terrain RGB",
                },
            },
            doc: "The type of the source.",
        },
        url: {
            type: "string",
            doc: "A URL to a TileJSON resource. Supported protocols are `http:`, `https:`, and `mapbox://<mapid>`.",
        },
        tiles: {
            type: "array",
            value: "string",
            doc: "An array of one or more tile source URLs, as in the TileJSON spec.",
        },
        bounds: {
            type: "array",
            value: "number",
            length: 4,
            default: [-180, -85.0511, 180, 85.0511],
            doc:
                "An array containing the longitude and latitude of the southwest and northeast corners of the source's bounding box in the following order: `[sw.lng, sw.lat, ne.lng, ne.lat]`. When this property is included in a source, no tiles outside of the given bounds are requested by Mapbox GL.",
        },
        minzoom: {
            type: "number",
            default: 0,
            doc: "Minimum zoom level for which tiles are available, as in the TileJSON spec.",
        },
        maxzoom: {
            type: "number",
            default: 22,
            doc:
                "Maximum zoom level for which tiles are available, as in the TileJSON spec. Data from tiles at the maxzoom are used when displaying the map at higher zoom levels.",
        },
        tileSize: {
            type: "number",
            default: 512,
            units: "pixels",
            doc: "The minimum visual size to display tiles for this layer. Only configurable for raster layers.",
        },
        scheme: {
            type: "enum",
            values: {
                xyz: {
                    doc: "Slippy map tilenames scheme.",
                },
                tms: {
                    doc: "OSGeo spec scheme.",
                },
            },
            default: "xyz",
            doc:
                "Influences the y direction of the tile coordinates. The global-mercator (aka Spherical Mercator) profile is assumed.",
        },
        attribution: {
            type: "string",
            doc: "Contains an attribution to be displayed when the map is shown to a user.",
        },
        "*": {
            type: "*",
            doc: "Other keys to configure the data source.",
        },
    },
    "lerc-image": {
        type: {
            required: true,
            type: "enum",
            values: {
                raster: {
                    doc: "A raster tile source.",
                },
                "raster-dem": {
                    doc: "A raster DEM source using Mapbox Terrain RGB",
                },
            },
            doc: "The type of the source.",
        },
        url: {
            type: "string",
            doc: "A URL to a TileJSON resource. Supported protocols are `http:`, `https:`, and `mapbox://<mapid>`.",
        },
        tiles: {
            type: "array",
            value: "string",
            doc: "An array of one or more tile source URLs, as in the TileJSON spec.",
        },
        bounds: {
            type: "array",
            value: "number",
            length: 4,
            default: [-180, -85.0511, 180, 85.0511],
            doc:
                "An array containing the longitude and latitude of the southwest and northeast corners of the source's bounding box in the following order: `[sw.lng, sw.lat, ne.lng, ne.lat]`. When this property is included in a source, no tiles outside of the given bounds are requested by Mapbox GL.",
        },
        minzoom: {
            type: "number",
            default: 0,
            doc: "Minimum zoom level for which tiles are available, as in the TileJSON spec.",
        },
        maxzoom: {
            type: "number",
            default: 22,
            doc:
                "Maximum zoom level for which tiles are available, as in the TileJSON spec. Data from tiles at the maxzoom are used when displaying the map at higher zoom levels.",
        },
        tileSize: {
            type: "number",
            default: 512,
            units: "pixels",
            doc: "The minimum visual size to display tiles for this layer. Only configurable for raster layers.",
        },
        scheme: {
            type: "enum",
            values: {
                xyz: {
                    doc: "Slippy map tilenames scheme.",
                },
                tms: {
                    doc: "OSGeo spec scheme.",
                },
            },
            default: "xyz",
            doc:
                "Influences the y direction of the tile coordinates. The global-mercator (aka Spherical Mercator) profile is assumed.",
        },
        "geojson-mask": {
            type: "*",
            doc: "A URL to a GeoJSON file, or inline GeoJSON.",
        },
        attribution: {
            type: "string",
            doc: "Contains an attribution to be displayed when the map is shown to a user.",
        },
        "*": {
            type: "*",
            doc: "Other keys to configure the data source.",
        },
    },
    "ags-dynamic": {
        type: {
            required: true,
            type: "enum",
            values: {
                raster: {
                    doc: "A raster tile source.",
                },
                "raster-dem": {
                    doc: "A raster DEM source using Mapbox Terrain RGB",
                },
            },
            doc: "The type of the source.",
        },
        url: {
            required: true,
            type: "string",
            doc: "A URL to a TileJSON resource. Supported protocols are `http:`, `https:`, and `mapbox://<mapid>`.",
        },
        params: {
            type: "object",
            doc: "custom params include token",
        },
    },
};

module.exports.mapboxSources = {
    geojson: {
        roundZoom: {
            type: "boolean",
            default: "true",
            doc:
                "Whether the canvas source is animated. If the canvas is static, `animate` should be set to `false` to improve performance.",
        },
        minzoom: {
            type: "number",
            minimum: 0,
            maximum: 24,
            doc:
                "The minimum zoom level for the layer. At zoom levels less than the minzoom, the layer will be hidden.",
        },
    },
};
